export default "/profile/images/instruction-3-ua.webp?0c87a1a3d508e0fac505dd6e08e22cfe";